import interceptorAxios from './InterceptorAxios';
const ServicioSucursal = {
    paginacion(objeto){
        return interceptorAxios.post("/sucursal/paginacion_sucursal.json",objeto);
    },
    guardar(objeto){
        return interceptorAxios.post("/sucursal/guardar_sucursal.json",objeto);
    },
    eliminar(objeto){
        return interceptorAxios.post("/sucursal/eliminar_sucursal.json",objeto);
    },
    busqueda_like(objeto){
        return interceptorAxios.post("/sucursal/buscar_sucursal_like.json",objeto);
    },
    lista_sucursales(){
        return interceptorAxios.post("/sucursal/buscar_sucursales.json");
    }
}
export default ServicioSucursal;